import styled from 'styled-components'
import { get, Select } from '@ally/metronome-ui'

export const StyledSelect = styled(Select)`
  &:before {
    display: none;
  }
  select {
    color: ${get.colors('bluesuedeshoes')};
    background-color: transparent;
    font-weight: bold;
    border: none;
    text-align-last: right;
    padding: 0 ${get.space('lg')} 0 ${get.space('xs')};
    height: auto;
    width: fit-content;
  }
  svg {
    right: -${get.space('xs')};
    width: 30px;
  }
`
